import TracksIcon from '@material-ui/icons/Map';
import TracksEdit from './tracksEdit';
import TracksList from './tracksList';
import TracksShow from './tracksShow';

export default {
  edit: TracksEdit,
  list: TracksList,
  show: TracksShow,
  icon: TracksIcon,
};
